import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Observable,  } from 'rxjs';
import { map,  } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { ErrorService } from '../error.service';
// import { ErrorService } from 'src/app/services/error.service';
@Injectable(
    {
        providedIn: 'root'
    }
)
export class Get271Logs extends Subject<DataStateChangeEventArgs>{
    constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
      super();
    }
    public outputValues(state): void {
      this.getList(state).subscribe(x => super.next(x));
    }
   
    getList(state?): Observable<DataStateChangeEventArgs> {
      return this.http.post<any>("api/SFTPDetail/GetSFTP_271Logs", state)
        .pipe(map(
          (response: any) =>
            <any>{
              result: response['result'],
              count: response['count']
            }
        ))
    }
  }